/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getConsentDecisionByToken} from '../api'

 export const useQueryGetConsentDecisionByToken = createReactQueryHook('getConsentDecisionByToken', getConsentDecisionByToken)
